export const mergeSchools = (schools) => {
  const { university = [], college = [] } = schools;

  const merged = university.concat(college);
  merged.sort((current, next) => current.shortname.localeCompare(next.shortname));

  return merged;
};

export const formatSchoolName = (school) => {
  let name = school.shortname;

  if (school.department) {
    name += ` - ${school.department}`;
  }

  if (school.name !== school.shortname) {
    name += ` (${school.name})`;
  }

  return name;
};
